import { motion } from 'framer-motion';
import {
  Building2, Cpu, Factory, HeartPulse, Landmark, Plane, ShoppingBasket, ShoppingCart, Truck, Zap,
} from 'lucide-react';
import { INDUSTRIES } from '../data';
import { EASE, SectionHead } from './shared';

const ICONS = {
  'Aviation, Logistics, SCM': Plane,
  'BFSI, Fintech, NBFC': Landmark,
  Manufacturing: Factory,
  'Utilities & Power': Zap,
  'Healthcare & Pharma': HeartPulse,
  FMCG: ShoppingBasket,
  PSUs: Building2,
  'Retail & Ecommerce': ShoppingCart,
  'Digital Natives': Cpu,
  'IT / ITES / GCC': Cpu,
  'Media, Telecom & Entertainment': Building2,
  'Education & EdTech': Building2,
};

export default function Industries() {
  return (
    <section id="industries" className="tex-diag relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute -right-40 top-10 h-[460px] w-[460px] rounded-full bg-lime/[0.07] blur-[140px]" />
      <div className="relative mx-auto w-full max-w-7xl px-5 md:px-8">
        <SectionHead
          eyebrow="Sectors"
          title={
            <>
              Industries in <span className="text-lime">Focus</span>
            </>
          }
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {INDUSTRIES.map((name, i) => {
            const Icon = ICONS[name] || Building2;
            return (
              <motion.div
                key={name}
                data-testid={`industry-card-${i}`}
                initial={{ opacity: 0, y: 28, scale: 0.96 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, delay: (i % 5) * 0.07, ease: EASE }}
                className="group relative flex h-full flex-col items-center justify-center overflow-hidden rounded-2xl border border-line/10 bg-ink-2/60 px-4 py-8 text-center transition-all duration-300 hover:-translate-y-1 hover:border-lime/50 hover:shadow-[0_10px_44px_rgba(153,204,0,0.14)]"
              >
                <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-gradient-to-r from-transparent via-lime to-transparent transition-transform duration-500 group-hover:scale-x-100" />
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-lime/30 bg-lime/5 transition-all duration-300 group-hover:scale-110 group-hover:bg-lime/15">
                  <Icon size={24} strokeWidth={1.6} className="text-lime" />
                </span>
                <p className="mt-5 font-display text-sm font-bold leading-snug tracking-tight sm:text-[15px]">{name}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
